/* unplugin-vue-components disabled */import { render } from "./PageNavBackLayoutCpt.vue?vue&type=template&id=213ee04a&scoped=true"
import script from "./PageNavBackLayoutCpt.vue?vue&type=script&lang=js"
export * from "./PageNavBackLayoutCpt.vue?vue&type=script&lang=js"

import "./PageNavBackLayoutCpt.vue?vue&type=style&index=0&id=213ee04a&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213ee04a"]])

export default __exports__